function secondsToMinutes(seconds) {
  return nearestInteger(seconds / 60);
}

function camelCaseToTitleCase(input) {
  // Split the input string at each uppercase letter and join with a space
  const result = input
    .replace(/([A-Z])/g, " $1") // Add a space before each uppercase letter
    .replace(/^./, (str) => str.toUpperCase()) // Capitalize the first letter
    .trim(); // Remove any leading or trailing spaces

  return result;
}

function nearestInteger(num) {
  return Math.round(num);
}

function formatNumber(num) {
  // Check if the number contains decimals
  if (num % 1 !== 0) {
    // If it contains decimals, return the number with only decimal place
    return num.toFixed(2); // Adjust the number of decimal places as needed
  } else {
    // If it's a whole number, return the number as is
    return num;
  }
}

function getPercentage(num, total) {
  return (num / total) * 100;
}

function formatTime(seconds) {
  // Calculate hours, minutes, and remaining seconds
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // Construct the formatted time string
  let formattedTime = "";
  if (hours > 0) {
    formattedTime += hours + "h ";
  }
  if (minutes > 0 || hours > 0) {
    formattedTime += minutes + "m ";
  }
  if (remainingSeconds > 0 || (minutes === 0 && hours === 0)) {
    formattedTime += remainingSeconds + "s";
  }

  return formattedTime.trim(); // Trim leading/trailing spaces
}

function isChildOverflowing(parentSelector, childSelector) {
  const parent = document.querySelector(parentSelector);
  const children = parent.querySelectorAll(childSelector);

  let totalWidth = 0;
  children.forEach((child) => {
    totalWidth += child.offsetWidth;
  });

  if (totalWidth > parent.offsetWidth) {
    return true;
  }

  return false;
}

function hexToRgba(color, alpha) {
  // If it's a CSS variable, return it with opacity using color-mix
  if (color.startsWith("var(")) {
    return `color-mix(in srgb, ${color} ${alpha * 100}%, transparent)`;
  }

  // Original hex conversion logic
  const hex = color.replace("#", "");
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export {
  camelCaseToTitleCase,
  isChildOverflowing,
  formatNumber,
  formatTime,
  nearestInteger,
  secondsToMinutes,
  getPercentage,
  hexToRgba,
};
